import { PAGINATION_BUTTON_COLOR } from '../../table.types';

const PAGINATION_BUTTON_ACTIVE_COLOR: Record<PAGINATION_BUTTON_COLOR, string> = {
    [PAGINATION_BUTTON_COLOR.THEME]: 'var(--color-primary-1)',
    [PAGINATION_BUTTON_COLOR.MUTED]: 'var(--color-neutral-3)',
};

export const getPaginationButtonActiveColor = (
    buttonColor: PAGINATION_BUTTON_COLOR = PAGINATION_BUTTON_COLOR.THEME,
): string => PAGINATION_BUTTON_ACTIVE_COLOR[buttonColor];
